import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahFooterLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={101} height={40} fill='none' {...props}>
    <g clipPath='url(#AgahFooterLogo_svg__a)'>
      <path
        fill='currentColor'
        d='M6.1 15.358a9.3 9.3 0 0 1 2.785-6.435 9.325 9.325 0 0 1 13.001-.065 9.3 9.3 0 0 1 2.85 6.407h6.056a15.34 15.34 0 0 0-3.069-9.107 15.377 15.377 0 0 0-25.075.687 15.34 15.34 0 0 0 .883 18.232 15.377 15.377 0 0 0 17.706 4.5l-2.281-5.604A9.32 9.32 0 0 1 7.223 19.73a9.3 9.3 0 0 1-1.094-4.373'
      />
      <path
        fill='#035888'
        d='m15.414 15.265 3.563 8.708a9.31 9.31 0 0 0 5.78-8.615v-.086h-9.343z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M58.043 24.685v6.102h21.058a.39.39 0 0 1 .392.391v2.734H55.364a.386.386 0 0 1-.385-.384l-.036-15.158V15.52h-6.84v6.195l.762.712v14.631a2.946 2.946 0 0 0 2.95 2.948h33.807v-12.36a2.94 2.94 0 0 0-1.823-2.738 3 3 0 0 0-1.135-.224H67.23l15.62-9.163h-9.114zM33.572 27.846h6.135v5.696a.39.39 0 0 1-.392.392h-5.7v-6.102h-6.143v12.196h15.392a2.95 2.95 0 0 0 2.722-1.82c.147-.357.222-.74.221-1.127V21.666H33.573z'
        clipRule='evenodd'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M82.543 23.88h6.121v-2.257h9.264a2.953 2.953 0 0 0 2.951-2.947v-3.147H85.465a2.95 2.95 0 0 0-2.706 1.851c-.144.36-.215.745-.209 1.132zM88.672 40.057h3.178a2.95 2.95 0 0 0 2.93-2.948V24.7h-6.108zM58.043 20.242v3.517l14.21-8.259H66.21z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='AgahFooterLogo_svg__a'>
        <path fill='#fff' d='M0 0h101v40H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAgahFooterLogo;
